var exports = {};

function backIn(t) {
  var s = 1.70158;
  return t * t * ((s + 1) * t - s);
}

exports = backIn;
export default exports;